import {
  BLOCKED_MESSAGES,
  buildTenantHandoffUrl,
  recordHandoffAttempt,
  tenantDirectLoginUrl,
} from '../utils/unifiedSignIn';
import { issueHandoffCode } from './handoffService';

export type TenantHandoffResult =
  | { ok: true; url: string }
  | { ok: false; message: string; fallbackUrl: string };

/**
 * Turn "this user is a tenant" into a redirect target on the tenant app.
 * - loop guard: stops a ping-pong between the apps
 * - asks the API for a one-time code; on ANY failure returns the tenant app's own sign-in as
 *   the fallback (never the token in a URL)
 */
export async function prepareTenantHandoff(token: string, tenantOrigin: string): Promise<TenantHandoffResult> {
  const fallbackUrl = tenantDirectLoginUrl(tenantOrigin);

  let storage: Storage | null = null;
  try {
    storage = window.sessionStorage;
  } catch {
    storage = null;
  }
  if (storage && !recordHandoffAttempt(storage)) {
    return { ok: false, message: BLOCKED_MESSAGES.looping, fallbackUrl };
  }

  const code = await issueHandoffCode(token);
  if (!code) return { ok: false, message: BLOCKED_MESSAGES.unavailable, fallbackUrl };

  try {
    return { ok: true, url: buildTenantHandoffUrl(tenantOrigin, code) };
  } catch {
    return { ok: false, message: BLOCKED_MESSAGES.unavailable, fallbackUrl };
  }
}
